export default __webpack_public_path__ + "static/media/podolsk_sellers.afc8c5f9.jpg";